import { Card, CardContent, Grid, Skeleton, Theme, Typography, useTheme } from '@mui/material';
import moment from 'moment';
import useMetricsDailyStatsCountersAllWeek from '../../hooks/useMetricsDailyStatsCountersAllWeek';
import StatsGraphD3 from './StatsGraphD3';
import ValueAndTrend from './ValueAndTrend';

const StatsCardFollowingActive = () => {
    const theme: Theme = useTheme();

    const { data: dailyStats, isLoading: dailyStatsLoading } = useMetricsDailyStatsCountersAllWeek();

    return (
        <Card variant="elevation">
            <CardContent
                sx={{
                    height: 150,
                    padding: 0,
                }}
            >
                {dailyStatsLoading ? (
                    <Skeleton />
                ) : (
                    <Grid container spacing={1} flexGrow={0} justifyContent="center" sx={{ height: '100%' }}>
                        <Grid
                            item
                            xs={12}
                            sx={{
                                paddingRight: {
                                    xs: theme.spacing(1),
                                    sm: theme.spacing(1.5),
                                },
                                marginTop: {
                                    xs: theme.spacing(1),
                                    sm: theme.spacing(1.5),
                                },
                                marginLeft: {
                                    xs: theme.spacing(1),
                                    sm: theme.spacing(1.5),
                                },
                            }}
                        >
                            <Grid container spacing={1} flexGrow={0} alignItems="center">
                                <Grid item xs>
                                    <Typography variant="h6" textAlign={'left'}>
                                        Following
                                    </Typography>
                                </Grid>
                                <Grid item xs="auto">
                                    <ValueAndTrend
                                        value={
                                            dailyStats &&
                                            dailyStats[0] &&
                                            dailyStats[0].counters &&
                                            dailyStats[0].counters.subscriptions &&
                                            dailyStats[0].counters.subscriptions.active !== undefined
                                                ? dailyStats[0].counters.subscriptions.active
                                                : undefined
                                        }
                                        previousValue={
                                            dailyStats &&
                                            dailyStats.length > 1 &&
                                            dailyStats[1].counters &&
                                            dailyStats[1].counters.subscriptions &&
                                            dailyStats[1].counters.subscriptions.active !== undefined
                                                ? dailyStats[1].counters.subscriptions.active
                                                : undefined
                                        }
                                        type={'number'}
                                        fractionDigits={0}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <StatsGraphD3
                                data={
                                    dailyStats
                                        ? dailyStats.map(d => {
                                              return {
                                                  time: moment(d._id).toDate(),
                                                  count: d.counters ? d.counters.subscriptions.active : 0,
                                              };
                                          })
                                        : []
                                }
                                type="number"
                                color={theme.palette.primary.main}
                            />
                        </Grid>
                    </Grid>
                )}
            </CardContent>
        </Card>
    );
};

export default StatsCardFollowingActive;
